/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';

/* Utils */
import { useFocusRestoredContext } from '../providers/RestoreFocusProvider';
import { getDisplayName } from './utils';

export function withCursorVisibilityFilter(WrappedComponent) {
  function WithCursorVisibilityFilter({
    className = '',
    hasFocusedChild = false,
    focused = false,
    ...props
  }) {
    const {
      isCursorVisible,
      isFocusRestored,
      cursorVisibilityChanged,
    } = useFocusRestoredContext();

    const forwardFocusedStates = !isCursorVisible && isFocusRestored;

    return (
      <WrappedComponent
        className={`${className}${isCursorVisible ? ' dtv-html5-s-cursor-visible' : ''}`}
        hasFocusedChild={forwardFocusedStates && hasFocusedChild}
        focused={forwardFocusedStates && focused}
        cursorVisible={isCursorVisible}
        focusRestored={isFocusRestored}
        cursorVisibilityChanged={cursorVisibilityChanged}
        {...props}
      />
    );
  }

  WithCursorVisibilityFilter.propTypes = {
    className: PropTypes.string,
    hasFocusedChild: PropTypes.bool,
    focused: PropTypes.bool,
  };

  WithCursorVisibilityFilter.displayName = `WithCursorVisibilityFilter(${getDisplayName(WrappedComponent)})`;

  return memo(WithCursorVisibilityFilter);
}

export default function withCursorVisibilityFilterFocusable(options) {
  return compose(
    withFocusable(options),
    withCursorVisibilityFilter,
  );
}
